import terms from "@/legal/terms.html?raw";
import priorityAddendum from "@/legal/priority-addendum.html?raw";
import collaborativeConsent from "@/legal/collaborative-consent.html?raw";

/** One of the documents in src/legal/ (our own static content), as shown in
 * the sign-up popup. */
function LegalDocument({ html }: { html: string }) {
  return <div className="legal-prose" dangerouslySetInnerHTML={{ __html: html }} />;
}

/** The Terms of Service. */
export function TermsDocument() {
  return <LegalDocument html={terms} />;
}

/** The Priority Addendum, accepted by a Priority signup (ADR-0004). */
export function PriorityAddendumDocument() {
  return <LegalDocument html={priorityAddendum} />;
}

/** The Collaborative data consent, accepted by a Priority signup that chooses
 * Collaborative. */
export function CollaborativeConsentDocument() {
  return <LegalDocument html={collaborativeConsent} />;
}
